export default __webpack_public_path__ + "static/media/Illustrations.53c73730.jpg";